import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const MiscellaneousLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_19_"
        x1="1209.303"
        x2="1286.501"
        y1="427.045"
        y2="427.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="18.54"
        y="29.37"
        width="69.87"
        height="69.5"
        rx="19.81"
        transform="translate(-14.63 15.82) rotate(-14.83)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_19_)"
      />
      <image
        width="56"
        height="56"
        transform="translate(19 44) rotate(-14.83)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_20_"
        x1="1291.531"
        x2="1368.728"
        y1="432.878"
        y2="432.878"
        gradientTransform="rotate(3.551 1340.948 459.91) scale(1.00002)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="104.78"
        y="16.71"
        width="68.24"
        height="67.88"
        rx="19.81"
        transform="translate(-3.95 12.53) rotate(-5.09)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_20_)"
      />
      <image
        width="56"
        height="56"
        transform="translate(108.5 25.5) rotate(-5.09)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_16_"
        x1="1107.988"
        x2="1204.671"
        y1="512.572"
        y2="512.572"
        gradientTransform="rotate(-33.382 1154.137 513.293)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="190.65"
        y="24.92"
        width="67.48"
        height="67.12"
        rx="19.81"
        transform="translate(22.47 -55.53) rotate(14.84)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_16_)"
      />
      <image
        width="60"
        height="60"
        transform="translate(202.8 21.8) rotate(14.84)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_17_"
        x1="1214.409"
        x2="1295.185"
        y1="504.259"
        y2="504.259"
        gradientTransform="rotate(7.406 1239.032 502.913)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="44.73"
        y="104.57"
        width="65.44"
        height="65.1"
        rx="19.81"
        transform="translate(-32.51 24.39) rotate(-14.83)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_17_)"
      />
      <image
        width="56"
        height="56"
        transform="translate(43 117) rotate(-14.83)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#38670A"
        d="M1352.7 482.9c3.1-3.2 2.7-15.6 2.7-15.6s3.5-2.3 6.4-.9c2.9 1.4 2.2 3.8 2.2 3.8s-2.5 11.4-7.3 15.6c-1.7-.5-4-2.9-4-2.9z"
      />
      <linearGradient
        id="SVGID_18_"
        x1="1302.628"
        x2="1391.211"
        y1="517.283"
        y2="517.283"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="127.65"
        y="97.92"
        width="67.48"
        height="67.12"
        rx="19.81"
        transform="translate(39.07 -36.96) rotate(14.84)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_18_)"
      />
      <image
        width="56"
        height="56"
        transform="translate(141 98) rotate(14.84)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <linearGradient
        id="SVGID_15_"
        x1="1239.549"
        x2="1319.724"
        y1="583.89"
        y2="583.89"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#C067EB" />
        <stop offset="0.983" stopColor="#8F28E0" />
      </linearGradient>
      <rect
        x="206.51"
        y="118.74"
        width="67.48"
        height="67.12"
        rx="19.81"
        transform="translate(47.03 -56.46) rotate(14.84)"
        fill="#fff"
        strokeMiterlimit="10"
        strokeWidth="4"
        stroke="url(#SVGID_15_)"
      />
      <image
        width="56"
        height="56"
        transform="translate(220.5 118) rotate(14.84)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-miscellaneous"
      transform="translate(1110, 470)"
    >
      <defs>
        <linearGradient
          id="aac822d0-0d59-4fba-86e7-92166caec238"
          x1="124.32"
          y1="133.52"
          x2="119.31"
          y2="319.63"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#663d3c" />
          <stop offset="0.01" stopColor="#663d3c" />
          <stop offset="0.32" stopColor="#794545" />
          <stop offset="0.64" stopColor="#834a4a" />
          <stop offset="1" stopColor="#874c4c" />
        </linearGradient>
        <linearGradient
          id="b7e23b81-377d-48ec-84b7-d7b2f66d2b9c"
          x1="254.52"
          y1="214.75"
          x2="235.5"
          y2="432.44"
          href="#aac822d0-0d59-4fba-86e7-92166caec238"
        />
        <linearGradient
          id="fa86e62b-419c-4a5c-9bf8-49c268a10f7f"
          x1="348.59"
          y1="196.2"
          x2="320.88"
          y2="513.47"
          href="#aac822d0-0d59-4fba-86e7-92166caec238"
        />
      </defs>
      <g id="e9a17962-53bb-42bf-9eaf-e837169c7442" data-name="island2">
        <g>
          <path
            d="M10,122.61s38.11,63,59.47,91.68c7.15,9.6,14.29-8,15.07-5,.66,2.55,9,21,16.65,26.51C117,247.22,144.8,268,163.83,267.3a104.71,104.71,0,0,1,24.92,18.52L214,324.74l201-38.07,43.85-25.81,22.21-37.25s55.5-96.3,54.72-99.57-33.89-54-33.89-54L397.68,184.67s19.67,50.84,15,51.93S273,211.57,260.6,202.86s-6.21-16.33-6.21-16.33-26.38-10.88-48.11-12S166.71,141.91,152.74,131s-37.24-4.36-55.09,4.35-35.7,2.18-34.14-7.62S10,122.61,10,122.61Z"
            fill="#874c4c"
          />
          <path
            d="M96.42,159.85c12.69-6.45,21.42-9.32,30.93,2.14s11.11,89.55,19.83,99.58c5.55,5.73-17.45,1.43-34.1-20.06S96.42,159.85,96.42,159.85Z"
            fill="url(#aac822d0-0d59-4fba-86e7-92166caec238)"
          />
          <path
            d="M223.84,297.38c19-3.22,28.82-50.86,28.82-50.86s9.52,47.28,17.84,53.73C247.9,304.55,223.84,297.38,223.84,297.38Z"
            fill="url(#b7e23b81-377d-48ec-84b7-d7b2f66d2b9c)"
          />
          <path
            d="M300.24,318.51c5.95-20.41,15.87-74.85,15.87-74.85L339.9,242s7.4,52.77,31.72,71.15S300.24,318.51,300.24,318.51Z"
            fill="url(#fa86e62b-419c-4a5c-9bf8-49c268a10f7f)"
          />
          <path
            d="M129.44,183.17c-.44-4.72.14-9.56-1.33-14.13-4.83-14.95-23-9.65-39.7-3-8.38,3.32-22.27-1-31.14,1.25s-20.55.21-23.75-7.08c-1.09-2.5-1-5.25-1.93-7.8-1.86-5.26-7.39-8.89-11.72-13-8.4-8-12.58-18.43-16.57-28.54C1.52,106.31-.28,101.66,0,96.91c.79-12.15,14.45-20.48,26.75-27C49.05,58.2,29.78,45.75,52,34c26.21-13.82,102.6-9.61,133.43-12.07,33.87-2.7,59.71-8.55,93.73-7.95,30.78.54,62.24-8.1,91.86-1.07,11.63,2.76,73.87,8.85,84.38,13.85,24,11.44,47.35,17.53,71.37,29,15.25,7.26-19.78,19-2.29,20.12,5.69.37,11.69.09,16.78,2.27,9.24,4,11.58,14.34,9.76,22.9s-6.61,16.61-7.36,25.28c-.3,3.42,0,7.08-2.07,10-5.42,7.87-23.31,6.13-25.72,15-.94,3.42,1.13,7.28-.83,10.38-3.12,4.93-15,7.94-10.51,12.05,1.08,1,2.77,1.24,4.21,1.79,7.94,3.08,4.93,14.25-3,17.35s-17.19.94-25.67-.87-18.3-3.06-25.28,1.36c-3.85,2.44-6.56,6.46-11.26,7.38-2.84.55-5.79-.2-8.7-.13-10.59.25-16.35,10.24-19.72,18.65l47.63,9.75c6.13,1.26,8.84,7.83-4.88,11.55s-28.41,3.84-42.84,3.92c-63.86.36-130.23,5.1-193.84.09C184.74,241.74,132.58,217,129.44,183.17Z"
            fill="#68c902"
          />
          <path
            d="M134.09,169.81c-14-5.74-19.76-1.85-16.06,1.5S151.54,177,134.09,169.81Z"
            fill="#68c902"
          />
          <path
            d="M47.92,171.91l.7-1.51c.73,2.1,4.75,2.17,5.57.1,1.05,1.65,3.12,3.57,4.87,2.49.47-.29.78-.76,1.23-1.07,1.51-1,3.66.09,4.91,1.36s2.53,2.88,4.41,2.94a7.6,7.6,0,0,0,.93-5.87,20.84,20.84,0,0,0,5.38,3.52,15.26,15.26,0,0,0,1.24-4.37c1.14,2.37,5,1.83,7.64.88l11.16-4A44.48,44.48,0,0,1,101.12,177c-1.06-4.78-1.67-10.69,2.66-13.59a45.66,45.66,0,0,0,.89,10.23c6.75-5.87,6.51-15.52,5.8-24-4,.77-7.88,2.25-11.81,3.42-7.28,2.17-14.89,3.26-22.46,4.33Q63,159.28,49.9,161.15c-2.76.39-8.12.2-8.68,3.5C40.88,166.61,45.73,171.91,47.92,171.91Z"
            fill="#68c902"
          />
          <ellipse
            cx="189.52"
            cy="174.66"
            rx="38.07"
            ry="8.95"
            fill="#54ba02"
          />
          <path
            d="M189.52,165.71c-18.36,0-33.68,3.06-37.27,7.12,6.49-2.75,19-4.61,33.3-4.61,21,0,38.07,4,38.07,8.95a2.78,2.78,0,0,1-.8,1.83c3-1.28,4.77-2.76,4.77-4.34C227.59,169.72,210.54,165.71,189.52,165.71Z"
            fill="#4fb002"
          />
          <ellipse cx="297.06" cy="83.85" rx="21.83" ry="5.13" fill="#54ba02" />
          <path
            d="M297.06,78.72c-10.53,0-19.31,1.75-21.37,4.08,3.72-1.57,10.88-2.64,19.09-2.64,12.06,0,21.83,2.3,21.83,5.13a1.6,1.6,0,0,1-.46,1c1.74-.74,2.73-1.58,2.73-2.49C318.88,81,309.11,78.72,297.06,78.72Z"
            fill="#4fb002"
          />
          <ellipse
            cx="310.52"
            cy="102.41"
            rx="30.51"
            ry="7.18"
            fill="#54ba02"
          />
          <path
            d="M310.52,95.23c-14.71,0-27,2.45-29.87,5.71,5.2-2.2,15.2-3.7,26.69-3.7,16.85,0,30.51,3.22,30.51,7.18a2.24,2.24,0,0,1-.64,1.47c2.43-1,3.82-2.22,3.82-3.48C341,98.45,327.37,95.23,310.52,95.23Z"
            fill="#4fb002"
          />
          <ellipse
            cx="457.54"
            cy="168.32"
            rx="26.44"
            ry="6.22"
            fill="#54ba02"
          />
          <path
            d="M457.54,162.1c-12.75,0-23.39,2.13-25.88,5,4.51-1.91,13.17-3.2,23.12-3.2,14.61,0,26.44,2.78,26.44,6.21a1.92,1.92,0,0,1-.55,1.27c2.1-.89,3.3-1.91,3.3-3C484,164.89,472.14,162.1,457.54,162.1Z"
            fill="#4fb002"
          />
          <ellipse
            cx="417.55"
            cy="161.34"
            rx="13.96"
            ry="3.28"
            fill="#54ba02"
          />
          <path
            d="M417.55,158.05c-6.73,0-12.34,1.13-13.66,2.62,2.38-1,6.95-1.7,12.21-1.7,7.71,0,14,1.47,14,3.29a1,1,0,0,1-.29.67c1.11-.47,1.74-1,1.74-1.59C431.51,159.52,425.26,158.05,417.55,158.05Z"
            fill="#4fb002"
          />
          <path
            d="M81.82,190.83s-11.11-.48-13,1.19-12.16.48-12.16.48l-1.58-5.73a67.48,67.48,0,0,0-4.5,5.49c-.26.72-1.32,3.82-1.32,3.82l2.38,7.16,1.59-5.49,4,1a26.78,26.78,0,0,1,1.06,3.82c0,.71,2.11-4.06,2.11-4.06l3.44,1.19,1.32-2.86,2.65,1.67.79,5L71,195.84l1.85,1.67,1.58-2.62,2.38-1.2Z"
            fill="#45a102"
          />
          <path
            d="M256.92,266.4l4.94,3.26,9.88.25,22.95-2.26s-8.74,4-9.53,4.2-15.25,1.09-15.25,1.09l-3.77,3.76-2.08-3.58-1.94-.33-1.06,4.89-2.38-5.83L255,273.92l-.53-3.76Z"
            fill="#45a102"
          />
          <path
            d="M271.09,244.26c7.18,1.57,16.23-.8,23.6-.42,5.36.27,9.32-.35,14.67-.72,37.53-2.56,74.63-.92,112.15-3.48,7.91-.54,15.93-1.08,23.73.23,1.86.31,4.19,1.42,3.69,3.06-.37,1.22-2.05,1.59-3.44,1.75l-23.93,2.65a8.41,8.41,0,0,1-4.58,7.61,24.1,24.1,0,0,0,.21-7.58c-4.4,1.09-9,1-13.6.88l-3.2-.08-19.34-.46,1.62,2.92a42.56,42.56,0,0,0-26.36-.76,56.55,56.55,0,0,1,12.4,4.31,47.22,47.22,0,0,1-25.51-4.87,8.68,8.68,0,0,1-8.92,1.44c-3,2.82-8.92,2.17-11.07-1.21l-1.07,12.86a28.8,28.8,0,0,1-5.85-14.32,9.12,9.12,0,0,1-9.26,2.27,39,39,0,0,1-23.65-1.24c-4.91-1.84-8.86-5-14.14-6-7.88-1.49-16.5.6-24.58-.1a186.48,186.48,0,0,1-23.77-4.08c-11-2.4-26.48-7.69-37.77-5.22.38,3.46,3.5,6.59,7,8,1.33.52,3.53.33,3.46-1,.78,1.79,1.7,3.73,3.59,4.62s4.88-.2,4.67-2.12c4.71,3.75,12,5.58,17.34,2.55,2.14,3.26,7.56,4.26,10.94,2l4.94,9.1a30.36,30.36,0,0,0,5-10.09c1.07,2.33,4.86,3.14,7,1.5,2.11,3.12,6.52,4.44,10.55,4.18s7.79-1.83,11.45-3.38l1.36,5.64c2-1.59,3.85-3.72,3.7-6.12a4.57,4.57,0,0,0-.73-2.17"
            fill="#68c902"
          />
          <path
            d="M436.11,211.81a17.46,17.46,0,0,0-5.67-5.47l12.34-1.45-5.13-1.73a68.74,68.74,0,0,0,30.18-2.41,62.18,62.18,0,0,0-14-3.27,23,23,0,0,1,15.78-3.2c3.76.61,8.58,1.78,10.67-1.11l7.23,2.1c.75-1.07-.45-2.38-1.59-3.12-9.32-6.12-21.62-7.82-33-6.07s-21.86,6.72-31.18,12.83a15.07,15.07,0,0,0-4.17,3.58c-2.25,3.17-6.31,15.15.85,15.54,4.19.23,3.52-3.91,5.66-5.28C424.91,212.24,435.34,210.64,436.11,211.81Z"
            fill="#68c902"
          />
          <path
            d="M68.73,29a8.08,8.08,0,0,0,3.56-3.69A8.55,8.55,0,0,0,81.72,27a7,7,0,0,0,4-7.92l3.82,11.2c7-7.79,16.55-16.44,27.33-14-4.89-.67-10,3-10.25,7.49a17.76,17.76,0,0,1,12.15.63A5,5,0,0,0,122,21.63c1.25,2.61,6.11,1.62,7.31-1s0-5.58-1.19-8.2a29.9,29.9,0,0,1,11.92,13l7.28-4.14c-1.66,1.42,2.38,2.52,4.28,1.37s5.9-1,4.91.84a81.89,81.89,0,0,1,6.29-19A32.89,32.89,0,0,0,166,21.82,6.78,6.78,0,0,0,169,18.76c-.13,1.32,1.73,2,3.2,2.12a61,61,0,0,0,40.22-9.79l-5.09,8.32a46.25,46.25,0,0,1,25.38-2.86l.23-6.47,13.14,5.65,3.34-3.9A26.68,26.68,0,0,0,255.79,18c-2.83,4.29-9.24,5.07-14.76,5.37Q210.21,25,179.33,25.7c-24.5.53-49.23.67-73.39,4.82-11.66,2-23.37,8.08-34.75,9.56C60.7,41.44,56.54,32.14,61,23.72A18.06,18.06,0,0,1,68.73,29Z"
            fill="#68c902"
          />
          <path
            d="M265.7,12.14c1.1.17,2.1.67,3.18.93C275,14.58,280,8.58,282.94,3.47l2.42,3a4.38,4.38,0,0,0,3.32-1.17l9.21,5.9A11.11,11.11,0,0,0,308.2,6.55c.08,3.4,5.12,4.91,8.71,3.89S323.43,7,327,6s8.64.53,8.69,3.93l4.14-1.73c-1.22.68.61,2.19,2,2.17A11.53,11.53,0,0,0,352.12,4l6.12,6.13,4.5-2.72a8.42,8.42,0,0,0,4,4.32A21.85,21.85,0,0,1,377.18,0a32.24,32.24,0,0,0-4,12.79l4.58-3.33c2.86,2.27,1.42,6.9-1.78,8.77s-7.28,1.81-11.09,1.7q-33.3-1-66.64-.06c-9.68.26-21.66,2.68-31.15,1.37-3.14-.43-5.51.79-7-2.58C258.72,15.54,261.86,11.53,265.7,12.14Z"
            fill="#68c902"
          />
          <path
            d="M522.92,48.79l-4.45,1.15-1.73-2.44c.27,1.31-1.87,2.15-3.14,1.45a4.61,4.61,0,0,1-2-3.45,25.75,25.75,0,0,1,.06-9.82,20.41,20.41,0,0,0-5.4,8.52l-1.38-2.47-2.37,1c-2.7.13-5-3.29-7.41-2.21a9.94,9.94,0,0,1-1.66.91,3.47,3.47,0,0,1-2.62-.92,26.75,26.75,0,0,0-13.67-4.66c4.51,6.92,12.84,11,20.93,14.34,5.78,2.39,33.49,15.82,32.69.89-1.25,1.16-3.95,1.6-5.3,2.57C525.27,53.43,522.45,48.91,522.92,48.79Z"
            fill="#68c902"
          />
        </g>
      </g>
      <g className="text" transform="translate(200 200)">
        <path
          fill="#ffffff"
          d="M20.1,14.4c-0.3-2.3-0.8-4.5-1.3-6.6c-0.1-0.5-0.3-1.1-0.4-1.6c0,0,0,0,0,0c-0.5-1.6-1-3.2-1.5-4.7
          c-0.1-0.4-0.3-0.7-0.5-0.8c-0.2-0.2-0.5-0.3-0.9-0.3c-0.1,0-0.2,0-0.3,0h-0.3c-0.2,0-0.4,0-0.6,0c-0.2,0-0.4,0-0.7,0.1
          c-0.7,0.1-1.1,0.4-1.3,1c-0.5,1.2-0.9,2.4-1.2,3.6c-0.3,1.2-0.6,2.4-0.9,3.6C9.8,7.2,9.4,6,9.1,4.8C8.7,3.6,8.3,2.5,7.8,1.3
          C7.6,1,7.5,0.7,7.3,0.5C7.1,0.4,6.8,0.3,6.5,0.3c-0.1,0-0.2,0-0.3,0H5.9c-0.2,0-0.4,0-0.7,0c-0.2,0-0.5,0-0.7,0.1
          C4.1,0.4,3.9,0.5,3.7,0.6C3.5,0.8,3.4,1,3.3,1.3C2.6,3.6,1.9,5.7,1.4,7.8c-0.5,2.1-1,4.2-1.3,6.4c0,0.1,0,0.2,0,0.2
          c0,0.1,0,0.2,0,0.2c0,0.5,0.3,0.8,0.8,0.9c0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.7,0,1.1,0c0.5,0,0.8-0.1,0.9-0.3C3.9,15.3,4,15,4,14.7
          c0.2-1.6,0.4-3.1,0.6-4.5c0.2-1.4,0.5-2.7,0.8-4C5.8,7.6,6.2,9,6.5,10.4c0.3,1.3,0.7,2.5,1.2,3.8c0,0.1,0.1,0.2,0.1,0.3
          c0.1,0.4,0.3,0.6,0.6,0.8c0.2,0.2,0.6,0.3,1,0.3c0.5,0,1-0.1,1.6-0.2c0.3-0.1,0.6-0.2,0.7-0.4c0.2-0.2,0.3-0.4,0.4-0.7
          c0.5-1.3,0.9-2.7,1.2-4c0,0,0,0,0,0c0.3-1.3,0.6-2.7,0.9-4c0.2,1,0.5,1.9,0.7,2.8c0.1,0.5,0.2,1.1,0.3,1.6c0.3,1.5,0.6,2.9,0.8,4.4
          c0.1,0.4,0.2,0.6,0.5,0.7c0.2,0.1,0.5,0.1,0.9,0.1s0.7,0,1.1-0.1c0.4,0,0.7-0.1,1-0.2c0.4-0.1,0.6-0.4,0.6-0.9
          C20.1,14.6,20.1,14.5,20.1,14.4z"
        />
        <path
          fill="#ffffff"
          d="M25.4,1.1c-0.1-0.3-0.2-0.5-0.4-0.7c-0.1-0.1-0.2-0.2-0.3-0.2h0c-0.1-0.1-0.2-0.1-0.4-0.1
          C24.1,0,23.7,0,23.3,0c-0.8,0-1.3,0.2-1.6,0.5c-0.3,0.3-0.5,0.8-0.5,1.5c0,0.4,0,0.8,0.1,1c0,0.1,0.1,0.2,0.1,0.3
          c0.1,0.1,0.1,0.2,0.2,0.3C21.8,3.9,22.1,4,22.3,4c0.3,0.1,0.6,0.1,1,0.1c0.4,0,0.8,0,1.1-0.1c0.3-0.1,0.5-0.2,0.7-0.4
          c0.2-0.2,0.3-0.4,0.3-0.6c0.1-0.2,0.1-0.5,0.1-0.8C25.6,1.8,25.5,1.4,25.4,1.1z M25.1,5.3c-0.1-0.1-0.2-0.2-0.4-0.2
          c-0.1,0-0.2,0-0.3,0H24c-0.3,0-0.6,0-0.9,0c-0.3,0-0.6,0.1-0.8,0.1c-0.3,0-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
          c-0.1,0.8-0.1,1.7-0.1,2.5c0,0.8,0,1.6,0,2.4c0,0.5,0,1,0,1.5c0,0.5,0,1,0.1,1.5c0,0.4,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3
          c0.4,0,0.8,0.1,1.2,0.1c0.3,0,0.5,0,0.6-0.1c0.2,0,0.3-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.2-0.4c0-0.2,0-0.3,0-0.6
          c0.1-1.4,0.2-2.8,0.2-4.2c0-1.3,0.1-2.8,0.1-4.3C25.2,5.6,25.1,5.4,25.1,5.3z"
        />
        <path
          fill="#ffffff"
          d="M32.2,8.5c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
          C35,8,35,7.6,35.1,7.2c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3C34,5.1,33.6,4.9,33,4.9
          c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7C27.6,6,27.3,6.3,27,6.7c-0.3,0.4-0.4,0.9-0.4,1.4
          c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5c0.3,0.1,0.6,0.3,0.8,0.4
          c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1c-0.3-0.1-0.6-0.2-0.8-0.3
          c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.4,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.2-0.1,0.3-0.1,0.5
          c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2c0.6-0.2,1.1-0.4,1.5-0.6
          c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.6-0.1-1-0.4-1.4c-0.2-0.4-0.5-0.7-0.9-1C33.4,10,33,9.8,32.6,9.6
          c-0.4-0.2-0.8-0.3-1.2-0.5C31,9,30.7,8.8,30.4,8.7c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
          c0.2,0,0.4,0,0.7,0.1v0.2C32.1,8.2,32.1,8.4,32.2,8.5z"
        />
        <path
          fill="#ffffff"
          d="M46.3,13.6c0-0.1-0.1-0.2-0.1-0.4c-0.1-0.2-0.2-0.4-0.2-0.5c-0.1-0.2-0.2-0.3-0.3-0.5
          c-0.2-0.3-0.3-0.4-0.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.4,0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.2-0.6,0.2
          c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.4-0.5-0.5-0.8
          c-0.1-0.3-0.2-0.6-0.2-1c0-0.4,0.1-0.7,0.2-1C40,9,40.2,8.7,40.5,8.5C40.7,8.3,41,8.1,41.4,8c0.3-0.1,0.7-0.2,1.1-0.3
          c0,0.2,0,0.4,0,0.7c0,0.2,0,0.4,0.1,0.6c0.1,0.6,0.4,0.9,1,1c0.3,0.1,0.7,0.1,1.2,0.1c0.3,0,0.5-0.1,0.6-0.2
          c0.1-0.1,0.2-0.3,0.2-0.6c0.1-0.5,0.1-1,0.1-1.5c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4-0.1-0.7c0-0.4-0.1-0.7-0.3-0.9
          c-0.1-0.2-0.4-0.3-0.7-0.5c-0.4-0.1-0.7-0.2-1.1-0.3c-0.4,0-0.7-0.1-1-0.1c-0.8,0-1.7,0.1-2.4,0.4c-0.8,0.3-1.5,0.7-2.1,1.2
          c-0.6,0.5-1.1,1.1-1.5,1.8c-0.4,0.7-0.6,1.4-0.6,2.2c0,0.3,0,0.6,0.1,0.9c0.1,0.4,0.2,0.7,0.3,1.1s0.4,0.8,0.6,1.2
          c0.3,0.4,0.6,0.8,1.1,1c0.4,0.3,1,0.6,1.7,0.8c0.7,0.2,1.4,0.3,2.3,0.3c0.4,0,0.8,0,1.1-0.1c0.4-0.1,0.8-0.1,1.1-0.3
          c0.4-0.1,0.7-0.2,1-0.4c0.3-0.2,0.6-0.3,0.8-0.5c0.2-0.2,0.3-0.4,0.3-0.6C46.3,13.8,46.3,13.7,46.3,13.6z"
        />
        <path
          fill="#ffffff"
          d="M57.8,8.3c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
          c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
          c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
          c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5C57,12.2,57,12.1,56.9,12c-0.1-0.1-0.1-0.1-0.3-0.1
          c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
          c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
          c0.1-0.1,0.1-0.3,0.1-0.5C58.1,9.3,58,8.9,57.8,8.3z M52.6,9.3c-0.7,0.1-1.4,0.1-2,0.1C50.7,9,51,8.6,51.5,8.3
          c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C54,9.1,53.3,9.2,52.6,9.3z"
        />
        <path
          fill="#ffffff"
          d="M63,2L63,2c0-0.4,0-0.7,0-1c0-0.3,0-0.6-0.1-0.7c-0.1-0.1-0.2-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
          c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.5,0.3c-0.1,0.1-0.1,0.3-0.2,0.7c0,0.1,0,0.2,0,0.3c-0.1,1.2-0.2,2.4-0.2,3.7
          c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
          h0.6c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.2-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.2-2.3s0.1-1.8,0.1-2.8c0-1,0-2,0.1-3.1
          s0-2.1,0-3.1C63,2.7,63,2.4,63,2z"
        />
        <path
          fill="#ffffff"
          d="M68.6,2c0-0.3,0-0.7,0-1c0-0.3,0-0.6-0.2-0.7c-0.1-0.1-0.3-0.2-0.5-0.2c-0.3,0-0.7,0-1.1,0.1
          c-0.4,0-0.8,0.1-1.1,0.2c-0.2,0.1-0.4,0.2-0.4,0.3c-0.1,0.2-0.2,0.5-0.2,1c0,0.2,0,0.3,0,0.5c-0.1,1-0.2,2-0.2,3.1
          c0,1.3-0.1,2.5-0.1,3.8c0,1.1,0,2.1,0,3.1c0,0.9,0.1,1.7,0.1,2.4c0,0.3,0.1,0.6,0.2,0.8c0.1,0.2,0.4,0.3,0.9,0.3c0.1,0,0.2,0,0.3,0
          H67c0.1,0,0.2,0,0.3,0c0.5,0,0.7-0.2,0.8-0.4c0.1-0.2,0.1-0.5,0.2-0.9c0.1-0.6,0.1-1.4,0.1-2.3c0.1-0.9,0.1-1.8,0.1-2.8
          c0-1,0.1-2,0.1-3.1c0-1.1,0-2.1,0-3.1V2.7C68.6,2.5,68.6,2.2,68.6,2z"
        />
        <path
          fill="#ffffff"
          d="M81.7,5.7c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.2s-0.3-0.1-0.5-0.2c-0.3-0.1-0.7-0.2-1.1-0.2
          c-0.4,0-0.7-0.1-1-0.1c-0.2,0-0.3,0-0.4,0.1C78.1,4.8,78,5,78,5.3c-0.6-0.3-1.2-0.4-1.9-0.4c-0.8,0-1.5,0.2-2.2,0.5
          c-0.7,0.3-1.4,0.8-2,1.4c-0.6,0.6-1,1.3-1.4,2.1c-0.4,0.8-0.5,1.6-0.5,2.6c0,0.6,0.1,1.2,0.3,1.8c0.2,0.5,0.5,1,0.9,1.4
          c0.4,0.4,0.9,0.7,1.4,0.9c0.5,0.2,1.2,0.3,1.8,0.3c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,1.1-0.5,1.5-0.9c0,0.3,0.1,0.5,0.1,0.7
          c0.1,0.2,0.3,0.3,0.7,0.3c0.1,0,0.2,0,0.3,0h0.8c0.2,0,0.3,0,0.4,0c0.4,0,0.6-0.2,0.8-0.3c0.2-0.2,0.2-0.5,0.3-0.9
          c0.2-1.3,0.3-2.7,0.3-4.1c0.1-1.4,0.1-2.8,0.1-4.1C81.7,6,81.7,5.8,81.7,5.7z M77.9,10c0,0.6-0.1,1.1-0.1,1.7
          c-0.3,0.3-0.7,0.6-1,0.7c-0.4,0.2-0.7,0.2-1.1,0.2c-0.6,0-1.1-0.2-1.4-0.5c-0.3-0.3-0.5-0.8-0.5-1.3c0-0.3,0.1-0.6,0.2-0.9
          c0.1-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.5-0.5,0.8-0.7C75.8,8,76.2,8,76.6,8c0.3,0,0.5,0,0.8,0.1c0.2,0,0.5,0.1,0.7,0.2
          C78,8.8,78,9.4,77.9,10z"
        />
        <path
          fill="#ffffff"
          d="M93.8,6.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.2-0.4-0.4-0.6-0.6c-0.3-0.2-0.7-0.3-1.1-0.4
          c-0.4-0.1-0.7-0.1-1-0.1c-0.6,0-1.2,0.1-1.8,0.3c-0.2,0.1-0.3,0.1-0.5,0.2c-0.4,0.2-0.8,0.4-1.2,0.7c0-0.1,0-0.2,0-0.3
          c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2,0-0.4,0-0.6,0c-0.2,0-0.5,0-0.7,0.1
          c-0.1,0-0.1,0-0.1,0h0c-0.2,0-0.4,0-0.5,0.1C84.5,5,84.3,5,84.2,5c-0.3,0.1-0.5,0.2-0.5,0.4c-0.1,0.2-0.1,0.5-0.1,0.8
          c0,0.3,0,0.5,0,0.8v0.8c0,1.1,0,2.2,0.1,3.4c0.1,1.1,0.2,2.2,0.3,3.3c0.1,0.3,0.1,0.6,0.3,0.8c0.1,0.2,0.4,0.3,0.9,0.3
          c0.1,0,0.2,0,0.3,0h0.7c0.1,0,0.2,0,0.3,0c0.5,0,0.8-0.1,0.9-0.2c0.2-0.1,0.2-0.3,0.2-0.6c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.2
          c-0.1-0.9-0.2-1.8-0.2-2.7c-0.1-0.9-0.1-1.8-0.1-2.8c0.4-0.3,0.8-0.5,1.2-0.6c0.4-0.1,0.8-0.2,1.1-0.2c0.3,0,0.5,0.1,0.6,0.3
          c0.1,0.2,0.2,0.5,0.2,0.8c0,0.9,0,1.6,0,2.2c0,0.6,0,1.1-0.1,1.5c0,0.4-0.1,0.7-0.1,1c0,0.2,0,0.4,0,0.6c0,0.5,0.2,0.8,0.7,0.9
          c0.3,0.1,0.7,0.1,1,0.2c0.3,0,0.6,0.1,0.8,0.1c0.4,0,0.6-0.1,0.7-0.3c0.1-0.2,0.2-0.4,0.2-0.7c0.1-0.6,0.2-1.3,0.2-1.9
          c0.1-0.6,0.1-1.3,0.2-1.9c0-0.6,0.1-1.1,0.1-1.7c0-0.5,0-1,0-1.3C94.2,7.2,94.1,6.6,93.8,6.2z"
        />
        <path
          fill="#ffffff"
          d="M106.1,8.4c-0.2-0.6-0.5-1.1-0.9-1.6c-0.4-0.5-1-1-1.6-1.3c-0.7-0.4-1.5-0.5-2.5-0.5c-0.7,0-1.4,0.1-2.1,0.4
          c-0.7,0.3-1.3,0.7-1.8,1.1c-0.5,0.5-0.9,1.1-1.2,1.8c-0.3,0.7-0.5,1.4-0.5,2.2c0,0.8,0.2,1.6,0.5,2.2c0.3,0.7,0.7,1.2,1.2,1.7
          c0.5,0.5,1.1,0.8,1.7,1.1c0.7,0.3,1.3,0.4,2,0.4c1,0,1.9-0.1,2.6-0.4s1.4-0.6,1.8-1c0.2-0.2,0.3-0.5,0.3-0.7v-0.2
          c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.1-0.5c0-0.2-0.1-0.3-0.1-0.5c-0.1-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.1-0.1-0.3-0.1
          c-0.1,0-0.2,0-0.5,0.1c-0.4,0.2-0.9,0.4-1.4,0.5c-0.5,0.1-0.9,0.2-1.3,0.2c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.8-0.5-1.1-0.8
          c0.6,0,1.2-0.1,1.8-0.1c0.6-0.1,1.2-0.1,1.8-0.2c0.6-0.1,1.1-0.2,1.6-0.3c0.5-0.1,0.9-0.2,1.3-0.4c0.2-0.1,0.4-0.2,0.4-0.3
          c0.1-0.1,0.1-0.3,0.1-0.5C106.4,9.4,106.3,8.9,106.1,8.4z M100.9,9.3c-0.7,0.1-1.4,0.1-2,0.1C99,9,99.3,8.6,99.8,8.3
          c0.4-0.3,0.9-0.4,1.4-0.4c0.3,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.5,0.7,0.9C102.3,9.2,101.6,9.3,100.9,9.3z"
        />
        <path
          fill="#ffffff"
          d="M118.1,7.8c-0.1-0.2-0.3-0.3-0.4-0.5c-0.6-0.6-1.3-1-2.2-1.2c0-0.2,0-0.3,0.1-0.3c0-0.1,0-0.1,0-0.2
          c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.3-0.1-0.5-0.1-0.8-0.2c-0.3,0-0.6-0.1-0.8-0.1c-0.7,0-1.5,0.1-2.2,0.4
          c-0.7,0.3-1.3,0.7-1.9,1.1c0,0,0,0,0,0c-0.6,0.5-1,1.1-1.4,1.8c-0.4,0.7-0.5,1.5-0.5,2.4c0,0.9,0.2,1.6,0.4,2.3
          c0.3,0.7,0.7,1.2,1.2,1.7c0.5,0.4,1.2,0.8,1.9,1c0.8,0.2,1.6,0.3,2.5,0.3c0.7,0,1.4-0.1,2-0.3c0.7-0.2,1.3-0.5,1.8-1
          c0.5-0.4,1-1,1.3-1.6c0.3-0.6,0.5-1.4,0.5-2.2C119,9.7,118.7,8.7,118.1,7.8z M115.4,11.6c-0.1,0.3-0.3,0.5-0.6,0.6
          c-0.2,0.2-0.5,0.3-0.8,0.4c-0.3,0.1-0.6,0.1-0.9,0.1c-0.3,0-0.6,0-0.9-0.1c-0.3-0.1-0.5-0.2-0.7-0.4c-0.2-0.2-0.4-0.4-0.5-0.6
          c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.8,0.2-1.4,0.7-1.9c0.5-0.5,1.1-0.8,1.8-0.9c0,0.2,0,0.4,0,0.5c0,0.1,0.1,0.2,0.2,0.3
          c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2,0.1,0.4,0.2c0.4,0.1,0.7,0.3,1,0.6c0.2,0.3,0.4,0.6,0.4,1C115.6,11.1,115.5,11.3,115.4,11.6z"
        />
        <path
          fill="#ffffff"
          d="M130.6,9.2c0-0.1,0-0.2,0-0.3c-0.1-1-0.2-2-0.2-3c-0.1-0.4-0.2-0.6-0.4-0.7C129.8,5,129.5,5,129.1,5
          c-0.2,0-0.4,0-0.7,0c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.1-0.7,0.2-0.9,0.4c-0.2,0.2-0.2,0.4-0.2,0.7c0,0.1,0,0.4,0.1,0.7
          c0,0.3,0.1,0.8,0.1,1.3c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.9,0.1,1.4c0,0.6,0.1,1.2,0.1,1.9c-0.4,0.3-0.8,0.5-1.2,0.6
          c-0.4,0.1-0.8,0.2-1.2,0.2c-0.3,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.6,0-1.1,0.1-1.7c0-0.6,0.1-1.1,0.1-1.6
          c0,0,0,0,0,0c0-0.5,0.1-0.9,0.1-1.2c0-0.4,0.1-0.6,0.1-0.8c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.3
          C123.2,5.1,123,5,122.8,5c-0.2,0-0.5,0-0.7,0c-0.5,0-0.8,0.1-1,0.2s-0.4,0.4-0.4,0.8c-0.1,0.6-0.2,1.1-0.2,1.7c0,0.1,0,0.1,0,0.2
          c-0.1,0.6-0.1,1.3-0.2,1.9c0,0.6-0.1,1.1-0.1,1.7c0,0.5,0,1,0,1.4c0,0.7,0.1,1.2,0.3,1.6c0.2,0.4,0.5,0.7,0.9,0.9
          c0.3,0.2,0.7,0.3,1.1,0.4c0.4,0.1,0.7,0.1,1,0.1c0.6,0,1.2-0.1,1.8-0.3c0.6-0.2,1.2-0.5,1.7-0.8c0,0.1,0,0.2,0,0.3
          c0,0.1,0,0.2,0,0.3c0,0.4,0.3,0.7,0.8,0.7c0.3,0,0.7,0,1.2-0.1c0.4-0.1,0.9-0.2,1.2-0.3c0.3-0.1,0.4-0.3,0.5-0.5
          c0.1-0.2,0.1-0.5,0.1-0.8c0-0.2,0-0.5,0-0.8v-0.8C130.7,11.5,130.7,10.3,130.6,9.2z"
        />
        <path
          fill="#ffffff"
          d="M137.5,8.5c0.1,0.1,0.3,0.2,0.6,0.2c0.4,0.1,0.9,0.1,1.3,0.1c0.3,0,0.5-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.3-0.5
          c0.1-0.3,0.1-0.6,0.2-1c0.1-0.4,0.1-0.7,0.1-1c0-0.3-0.1-0.5-0.2-0.6c-0.1-0.2-0.3-0.3-0.5-0.3c-0.4-0.1-0.9-0.3-1.5-0.4
          c-0.5-0.1-1.1-0.1-1.6-0.1c-0.6,0-1.2,0.1-1.8,0.2c-0.6,0.2-1.1,0.4-1.5,0.7c-0.5,0.3-0.8,0.7-1.1,1.1s-0.4,0.9-0.4,1.4
          c0,0.4,0,0.7,0.1,0.9c0.1,0.2,0.1,0.3,0.2,0.4c0.2,0.4,0.5,0.7,0.8,1c0.3,0.3,0.7,0.5,1.1,0.7c0.4,0.2,0.7,0.3,1.1,0.5
          c0.3,0.1,0.6,0.3,0.8,0.4c0.2,0.1,0.3,0.3,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4c-0.2,0.1-0.5,0.1-0.8,0.1c-0.2,0-0.5,0-0.8-0.1
          c-0.3-0.1-0.6-0.2-0.8-0.3c-0.3-0.1-0.5-0.2-0.6-0.2c-0.2,0-0.3,0.1-0.5,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.1,0.2-0.2,0.5-0.2,0.7
          c0,0.2-0.1,0.3-0.1,0.5c0,0.3,0.2,0.6,0.6,0.7c0.4,0.2,0.9,0.3,1.4,0.4c0.5,0.1,1,0.1,1.6,0.1c0.7,0,1.3-0.1,1.9-0.2
          c0.1,0,0.2-0.1,0.3-0.1c0.4-0.1,0.8-0.3,1.2-0.5c0.4-0.3,0.8-0.6,1-1c0.2-0.4,0.4-0.8,0.4-1.3c0-0.2,0-0.5-0.1-0.6
          c-0.1-0.3-0.2-0.5-0.3-0.8c-0.2-0.4-0.6-0.7-0.9-1c-0.2-0.1-0.4-0.3-0.7-0.4c0,0,0,0,0,0c-0.2-0.1-0.3-0.2-0.5-0.3
          c-0.4-0.2-0.8-0.3-1.2-0.5c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.4-0.3-0.4-0.4c0-0.2,0.1-0.4,0.4-0.5c0.2-0.1,0.6-0.1,0.9-0.1
          c0.2,0,0.4,0,0.7,0.1v0.2C137.4,8.2,137.4,8.4,137.5,8.5z"
        />
      </g>
      <g id="b43808da-5d79-47ff-8a83-f115f0235b9e" data-name="decor isl2">
        <ellipse cx="370" cy="188.39" rx="25.46" ry="12.49" fill="#4fb002" />
        <g>
          <ellipse cx="54.83" cy="122.11" rx="23.67" ry="5.8" fill="#54ba02" />
          <path
            d="M69.53,105.37c0,11.22-3.55,22.86-20.9,23.28-16.37.39-22.09-12.06-22.09-23.28S36.75,88,48.63,88,69.53,94.15,69.53,105.37Z"
            fill="#e7fcfd"
          />
          <path
            d="M47.14,115.24c11.61,0,18.42-5.11,18.79,5.3,2.78-4.3,3.6-9.78,3.6-15.17,0-11.22-9-17.35-20.91-17.35s-22.08,6.13-22.08,17.35a21.72,21.72,0,0,0,.76,6.6A65.71,65.71,0,0,0,47.14,115.24Z"
            fill="#acdef3"
          />
          <path
            d="M79.46,96.3c0,8.12-14.3,14.7-31.94,14.7s-31.93-6.58-31.93-14.7,16-19.5,33.64-19.5S79.46,88.18,79.46,96.3Z"
            fill="#ffa511"
          />
          <path
            d="M70.22,83.14c3.8,2.79,6.08,8,6.08,11,0,7.39-18,12.36-34.93,12.36-7,0-15.42-.65-20.57-2.37C25.87,108.41,38.16,111,50,111c16.9,0,30.59-6,30.59-13.38C80.63,92.82,76.43,87.17,70.22,83.14Z"
            fill="#ff6911"
          />
          <ellipse cx="34.72" cy="92.01" rx="8.64" ry="3.55" fill="#feb93e" />
          <ellipse cx="60.45" cy="89.78" rx="6.36" ry="2.62" fill="#feb93e" />
          <ellipse cx="43.04" cy="81.97" rx="3.47" ry="1.43" fill="#feb93e" />
          <path
            d="M65.09,124.43a4,4,0,0,0-2.41,2.4,12.77,12.77,0,0,0-.12-3.38l-1.26,2-.37-1.21a11,11,0,0,0-1.86,2,13.66,13.66,0,0,0-3.5-5.91c-1,1.41-.3,3.41-.56,5.14a.82.82,0,0,1-.27.58.87.87,0,0,1-.6.07,7.1,7.1,0,0,1-3.81-1.83l-.47,1.74a1.06,1.06,0,0,0-.47-.73l-.32,1.2a3.52,3.52,0,0,0-4.78-.43,12.71,12.71,0,0,0,5.61,2.47,54.57,54.57,0,0,0,14.33,1.7c4.14-.14,3.72-3,4.23-6.39A8.65,8.65,0,0,0,65.09,124.43Z"
            fill="#68c902"
          />
        </g>
        <g>
          <ellipse cx="72.33" cy="134.32" rx="13.86" ry="6.07" fill="#54ba02" />
          <path
            d="M62.72,76.29c-.21,4.07.43,13.47-2.35,19.24s-7.06,8.55-4.06,16.25S59.09,130,58.44,132.3s-.85,3.21-.85,3.21a2.87,2.87,0,0,0,3,1.17c2.14-.32,3.32-3.2,3.42-4.81s1.18-9.3-.32-16.88A66.84,66.84,0,0,1,62,100.56c-.1-4.71,2-7.49,2.67-11s1.18-13,1.18-13,7.16.85,8-.11c.85-2.14.53-9.41-8.55-9s-11,6.63-10.59,8.34S62.72,76.29,62.72,76.29Z"
            fill="#e53666"
          />
          <path
            d="M65.82,76.51s7.16.85,8-.11c.85-2.14.53-9.41-8.55-9s-11,6.63-10.59,8.34,8,.53,8,.53,0,.14,0,.21a12.33,12.33,0,0,1,1.51.11c.46.08,1,.15,1.58.22C65.81,76.63,65.82,76.51,65.82,76.51Z"
            fill="#e53666"
          />
          <path
            d="M62.72,76.29c.53-.32,3.1.22,3.1.22s-.64,11.86-1.28,13.79C63.58,78,62.72,76.29,62.72,76.29Z"
            fill="#bb3666"
          />
          <path
            d="M61.44,140.21c0,2.14,2.14,3.1,4.59,3.42s6.63-.32,6.84-1.92,0-29.4-.64-30.79c1.93-.42,6.74-2,6.42-5.34S76.29,97.67,69.56,97s-11.54,2.67-10.9,7,6.84,7,6.84,7a66.14,66.14,0,0,1,1,11C66.57,128.88,61.44,140.21,61.44,140.21Z"
            fill="#a77de8"
          />
          <path
            d="M63.68,67.42c-2,.34-5.34,1.5-6.3,3.1s3.52,3,6.94,2.67,8,.75,8.34-1.28S72.23,68.7,70,68A13,13,0,0,0,63.68,67.42Z"
            fill="#e5679f"
          />
          <ellipse cx="60.16" cy="72.8" rx="2.14" ry="1.07" fill="#e5d7b1" />
          <ellipse cx="62.51" cy="71.06" rx="1.02" ry="0.51" fill="#e5d7b1" />
          <ellipse cx="59.09" cy="70.74" rx="1.38" ry="0.69" fill="#e5d7b1" />
          <ellipse cx="68.85" cy="73.55" rx="1.96" ry="0.98" fill="#e5d7b1" />
          <ellipse cx="71.28" cy="71.82" rx="0.85" ry="0.42" fill="#e5d7b1" />
          <ellipse cx="65.64" cy="69.19" rx="1.82" ry="0.91" fill="#e5d7b1" />
          <path
            d="M66,143.63c2.46.32,6.63-.32,6.84-1.92s0-27.54-.57-30.55c-2.52,0-5.81-.32-7.61-.51.49.25.81.38.81.38a66.14,66.14,0,0,1,1,11c.11,6.84-5,18.17-5,18.17C61.44,142.35,63.58,143.31,66,143.63Z"
            fill="#8a6ce8"
          />
          <path
            d="M72.28,111.08a.6.6,0,0,0,0-.16c1.93-.42,6.74-2,6.42-5.34a9.88,9.88,0,0,0-1.74-4.76c-.19,6.26-8.2,9-16.66,6.51a15,15,0,0,0,4.41,3.3l.84.4S68.9,111.23,72.28,111.08Z"
            fill="#7b5dce"
          />
          <path
            d="M65.5,111s3.53,3.37,5.4,2.78,1.33-2.89,1.33-2.89S66.3,111.14,65.5,111Z"
            fill="#5641ce"
          />
          <ellipse cx="64.29" cy="103.8" rx="3.63" ry="1.57" fill="#e59be8" />
          <ellipse cx="66.78" cy="100.16" rx="1.62" ry="0.7" fill="#e59be8" />
          <ellipse cx="70.7" cy="103.8" rx="1.62" ry="0.7" fill="#e59be8" />
          <path
            d="M82.58,162.49H59.49c-.58-.65-1.15-1.33-1.73-2l.84-1c-.05-.47-.11-.63-.15-.32,0-.38-.09-3.12-.05-4.91s.1-3,.08-3.53a10.05,10.05,0,0,1,.1,1.81c0-1.31.06-2.34.11-3a28.71,28.71,0,0,0,.08-3.07,65.34,65.34,0,0,1,.17,7.84,11.26,11.26,0,0,1,.12-1.52V153c.12-2.87.22-4.83.18-5.87a33.76,33.76,0,0,1,.21,4.93c.08-3.07.2-5.34.34-6.57a57.18,57.18,0,0,0,.26-7,106.48,106.48,0,0,1,.33,11.37,7.16,7.16,0,0,1,.14-.86,16.34,16.34,0,0,0,.28-3.8c.07.35.13,2.84.09,6.11.09-.75.18-1.3.26-2.14a69.58,69.58,0,0,0,.37-8.22c0-.84.1-1.06.13-.51.05.84.09,1.75.12,2.71a21.74,21.74,0,0,1,.21,3.65c0-2.66.12-4.76.22-6a54.52,54.52,0,0,0,.15-6.24c.15-.32.49,6.35.35,16a21.38,21.38,0,0,1,.26-3.09v.35c.23-5.85.43-9.83.36-11.95a70.78,70.78,0,0,1,.43,10c.15-6.25.41-10.87.69-13.38A112.37,112.37,0,0,0,65,118.14c.27,0,.69,9.43.68,23.17a10.32,10.32,0,0,1,.29-1.77,33.71,33.71,0,0,0,.56-7.73c.14.72.26,5.78.19,12.44.18-1.52.36-2.64.53-4.35A146.62,146.62,0,0,0,68,123.16c0-1.72.2-2.17.26-1,.34,5.6.41,12.59.17,20.63-.12,3.83-.27,7.05-.43,9.69l.2-.05a.28.28,0,0,0,0-.09c.12-1.09.25-1.81.37-3A91.15,91.15,0,0,0,69,138.8c0-1.08.13-1.36.17-.65.21,3.52.25,7.91.1,13,0,.37,0,.71,0,1.06l.7-.08c0-.3,0-.6,0-.88.06-2.37.12-4,.1-4.64a13.77,13.77,0,0,1,.14,2.38c0-1.73.07-3.09.14-3.91a35.63,35.63,0,0,0,.1-4,82.53,82.53,0,0,1,.22,10.32,13.27,13.27,0,0,1,.17-2v.23c.15-3.78.28-6.36.23-7.73a44.66,44.66,0,0,1,.28,6.48c.1-4,.26-7,.45-8.65a74.38,74.38,0,0,0,.33-9.22c.18,0,.45,6.1.44,15a7.36,7.36,0,0,1,.19-1.14,21.7,21.7,0,0,0,.37-5c.09.46.16,3.74.12,8.05.11-1,.23-1.71.34-2.82a96.58,96.58,0,0,0,.49-10.83c0-1.11.13-1.4.17-.67.22,3.62.27,8.15.11,13.35-.07,2.38-.17,4.4-.27,6.07l.14,0c.07-.67.15-1.13.23-1.86a61.09,61.09,0,0,0,.3-6.81c0-.69.08-.88.11-.42.14,2.28.17,5.12.07,8.39q0,.47,0,.9c3.62,1.22,6.41,4.13,9.38,7.77C83.72,161.16,83.15,161.84,82.58,162.49Zm-21-7c0-.44,0-.89,0-1.34-.05.82-.09,1.55-.14,2.18l.09-.09C61.56,156,61.58,155.74,61.6,155.51Z"
            fill="#68c902"
          />
        </g>
      </g>
      <g id="a8d76bbd-4957-4f79-830c-e2524f2e3736" data-name="misc flag">
        <g>
          <path
            d="M371.75,191.81c0,3.42-6,6.19-13.37,6.19S345,195.23,345,191.81c0-.72.05-2.78.05-2.78s7.47-3.42,13.32-3.42S371.72,189,371.72,189,371.75,191.06,371.75,191.81Z"
            fill="#8abcf8"
          />
          <ellipse cx="358.38" cy="189.21" rx="13.37" ry="6.2" fill="#9ae1f8" />
          <path
            d="M358,187.67c1.1,1.05,11-2.48,11-2.48s-3.69-1.44-4.35-1.61a37.7,37.7,0,0,0-7.71,2.48Z"
            fill="#8aa6f8"
          />
          <path
            d="M358.56,188.32h-2.17V32.86l2-21.44,2,21.44V186.42A1.86,1.86,0,0,1,358.56,188.32Z"
            fill="#9ae1f8"
          />
          <path
            d="M358.37,11.42l-.91,9.87L358.55,33V188.32h0a1.86,1.86,0,0,0,1.82-1.9V32.86Z"
            fill="#8abcf8"
          />
          <path
            d="M331.44,53.51s.43,16.44,8.36,40c5.59,16.58,10.64,54.31,7.44,63.52,8.11-1,20.6-14.65,20.6-14.65s10.8,8.77,10.8,16.58c13-12.42,17.72-32.05,17.92-58.29C396.74,77.4,382,53.81,382,53.81Z"
            fill="#5e28bd"
          />
          <path
            d="M356.39,32.86V43.41a3.89,3.89,0,0,0,2.48.56c.38,0,1.12-.22,1.5-.26V32.86l-2-21.44Z"
            fill="#cfdff1"
          />
          <path
            d="M358.37,11.42,357.94,16l1.44,15.39.19,11.22a11.94,11.94,0,0,1-1.68.06,7.13,7.13,0,0,1-1.5-.29v1a3.89,3.89,0,0,0,2.48.56c.38,0,1.12-.23,1.5-.26V32.86Z"
            fill="#bad2f1"
          />
          <path
            d="M360.56,43.08c0,.52-1,1-2.17,1s-2.17-.43-2.17-1"
            fill="none"
            stroke="#cfdff1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="323.63"
            y="50.07"
            width="66.54"
            height="3.61"
            rx="1.8"
            transform="translate(-0.52 3.68) rotate(-0.59)"
            fill="#9ae1f8"
          />
          <path
            d="M331.49,53.88s1.08,15.13,9,38.66c5.59,16.58,11,55,7.79,64.25,8.11-1,20.25-15.37,20.25-15.37s10.8,8.76,10.8,16.57c13-12.41,17.73-32,17.93-58.28.17-23.24-14.54-46.84-14.54-46.84Z"
            fill="#c067eb"
          />
          <path
            d="M333.69,50.3a2.45,2.45,0,0,1-.3,3.67l17.09-.14s2.13-1.88,0-3.66C344.91,50,333.69,50.3,333.69,50.3Z"
            fill="#c067eb"
          />
          <path
            d="M367,49.88a2.44,2.44,0,0,1-.31,3.66c6.95,0,17.09-.14,17.09-.14s2.14-1.88,0-3.65C378.21,49.6,367,49.88,367,49.88Z"
            fill="#c067eb"
          />
          <path
            d="M361.07,42.08c0,.61-1.13,1.1-2.53,1.1s-2.52-.49-2.52-1.1"
            fill="none"
            stroke="#cfdff1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M390.17,51.32a1.57,1.57,0,0,0-.47-1.11,1.58,1.58,0,0,1-1.5,1.14L324.84,52a1.55,1.55,0,0,1-1.13-.46,1.45,1.45,0,0,0-.08.47v.42a1.6,1.6,0,0,0,1.6,1.58l63.36-.66a1.59,1.59,0,0,0,1.58-1.6Z"
            fill="#8abcf8"
            opacity="0.31"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M379.47,112.19l-9.21-3.86a2.23,2.23,0,0,0-2.08.19l-8.4,5.4a2.25,2.25,0,0,1-3.46-2.08l.82-10a2.27,2.27,0,0,0-.82-1.93l-7.73-6.32a2.25,2.25,0,0,1,.91-3.94l9.71-2.29A2.25,2.25,0,0,0,360.8,86l3.62-9.31a2.25,2.25,0,0,1,4-.35l5.18,8.53a2.24,2.24,0,0,0,1.8,1.08l10,.57A2.25,2.25,0,0,1,387,90.28l-6.51,7.56a2.26,2.26,0,0,0-.47,2l2.54,9.66A2.26,2.26,0,0,1,379.47,112.19Z"
            fill="#ffdc05"
          />
          <path
            d="M369.8,58.89a61.57,61.57,0,0,1,17.55,2.66c-2.52-5.22-4.62-8.68-4.62-8.68l-51.24,1a117.31,117.31,0,0,0,3,17.33C344.06,63.89,357.2,58.89,369.8,58.89Z"
            fill="#8f28e0"
          />
          <ellipse
            cx="365.22"
            cy="84.72"
            rx="6.5"
            ry="2.15"
            transform="translate(203.82 423.12) rotate(-77.56)"
            fill="#fff39d"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(60, -20)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default MiscellaneousLink;
